var time = {
  ms: function ms(seconds) {
    return seconds * 1000;
  },
  s: function s(milliseconds) {
    return milliseconds / 1000;
  }
};
export { time };